import { getService, Environments } from '@innovyze/stylovyze';
import { formatUrlTrailing } from '@Utils/urlFormatting';
import config from './config.api';

// See comments in package.md wrt eslint-disable-line below
const apiEnv =
	(localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined; // eslint-disable-line

export const tilesBaseUrl = formatUrlTrailing(
	getService('tiles', config, apiEnv),
);
